import React, { useEffect ,useState} from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import '../assets/css/feedback.less';
import topImg from '../assets/images/top-bg.png';
import helpImg from '../assets/images/top-help.png';
import suggestImg from '../assets/images/suggest.png';
import summaryImg from '../assets/images/summary.png';
import fileImg from '../assets/images/file.png';
import fileItemImg from '../assets/images/file-item.png';
import {getFeedback} from '../api/request';
import {downloadFile,getUrlParam} from '../utils';
const week = ['周日','周一','周二','周三','周四','周五','周六'];
const FeedbackReport = () => {
    const [ report,setReport ] = useState({});
    const getTimeFormat = (start,end) => {
        if (start && end){
            const time = `${moment(start).format('HH:mm')}~${moment(end).format('HH:mm')}`;
            const weekDay = week[moment(start).day()];
            const date =  moment(start).format('MM-DD');
            return `${date} ${weekDay} ${time}`;
        }
        return '';

    };
    //查询报告数据
    const getReport = async() => {
        const res = await getFeedback({processId:getUrlParam('processId')});
        if (res.data.status === 0){
            setReport(res.data.result || {});
        }
    };
    const saveFileHandel = (fileUrl,fileName) => {
        downloadFile(fileUrl,fileName);
    };
    useEffect(() => {
        getReport();
        getTimeFormat();
    },[]);
    return (
        <div className="feed-back-page">
            <div className="feedback-head-wrapper">
                <div className="head-inner">
                    <img
                        className="top-bg-img"
                        src={topImg} />
                    <img
                        className="top-help-img"
                        src={helpImg} />
                    <div className="title-content">
                        <div className="english">
                            Learning Feedback Report
                        </div>
                        <div className="text">
                            学习反馈报告
                        </div>
                    </div>
                </div>
            </div>
            <div className="feedback-content-wrapper">
                <div className="content-com-ui content-time-wrapper">
                    <div className="line-time-info">
                        <span className="left-label">
                            辅导时间：
                        </span>
                        <span className="right-value">
                            {getTimeFormat(report.startTime,report.endTime)}
                        </span>
                    </div>
                    <div className="line-time-info">
                        <span className="left-label">
                            老师姓名：
                        </span>
                        <span className="right-value">
                            {report.teacherName}
                        </span>
                    </div>
                    <div className="line-time-info">
                        <span className="left-label">
                            辅导科目：
                        </span>
                        <span className="right-value">
                            {report.counselingSubjectName}
                        </span>
                    </div>
                </div>
                <div className="content-com-ui content-summary-wrapper">
                    <div className="title-line">
                        <img
                            className="title-img"
                            src={summaryImg} />
                        <span>内容总结</span>
                    </div>
                    <div className="content-com-text-ui">
                        {report.summary}
                    </div>
                </div>
                <div className="content-com-ui content-suggest-wrapper">
                    <div className="title-line">
                        <img
                            className="title-img"
                            src={suggestImg} />
                        <span>学习建议</span>
                    </div>
                    <div className="content-com-text-ui">
                        {report.suggest}
                    </div>
                </div>
                {
                    report.feedbackFiles && report.feedbackFiles.length ? (
                        <div className="content-file-wrapper">
                            <div
                                className="title-line title-line-file"
                            >
                                <img
                                    className="title-img"
                                    src={fileImg} />
                                <span>附件资料</span>
                            </div>
                            <div className="file-list">
                                {
                                    report.feedbackFiles.map((file,index) => (
                                        <div
                                            className="file-item"
                                            key={index.toString()}
                                        >
                                            <img
                                                className="file-img"
                                                src={fileItemImg} />
                                            <span onClick={() => window.open(file.path,'_blank')}>
                                                {file.name}
                                            </span>
                                            <span
                                                className="btn-download"
                                                onClick={() => saveFileHandel(file.path,file.name)}
                                            >
                                                保存本地
                                            </span>
                                        </div>
                                    ))
                                }
                                
                            </div>
                        </div>
                    ) : null
                }
                

            </div>
        </div>
    );
};

export default withRouter(FeedbackReport);